import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

type Props = {
  children: JSX.Element;
  requireApproved?: boolean;
  requireRole?: ("admin" | "editor")[];
};

export const ProtectedRoute: React.FC<Props> = ({
  children,
  requireApproved,
  requireRole,
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: "1rem" }}>Lade...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireApproved && !(user.status === "approved" || user.status === "paid")) {
    return <Navigate to="/not-approved" replace />;
  }

  if (requireRole && !requireRole.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};
